import { extend } from 'underscore';
import { uiblockerStyle, glyphIconStyle, helpbuttonStyle, inputFieldStyle, tableStyle, buttonInputStyle, learnMoreStyle } from '@bingads-webui-campaign-react/common-styles';
import { getCommonStyle, importUiBlockerStyle } from './common-style';

export const getFileImportStyle = (_, { palette = {} }) => ({
  '@global': extend(
    {},
    uiblockerStyle({ palette }),
    glyphIconStyle({ palette }),
    helpbuttonStyle({ palette }),
    inputFieldStyle({ palette }),
    importUiBlockerStyle({ palette })
  ),
  ...getCommonStyle({ palette }),
  fileImportPage: extend(
    {},
    tableStyle({ palette }),
    buttonInputStyle({ palette }),
    learnMoreStyle({ palette }),
    {
      '& .import-preview-grid .table, .import-summary-grid .table': {
        '& > thead > tr > th': {
          borderTop: '2px solid #81868B !important',
          borderBottom: '2px solid #81868B !important',
        },
        '& > tbody > tr > td': {
          padding: 8,
        },
      },
    },
    {
      '& .column-matching-grid': {
        maxHeight: '900px',
        overflowY: 'auto',
        overflowX: 'auto',
        '& tbody tr': {
          height: '35px',
          padding: '4px',
        },
        '& col[class^="col-"]': {
          width: '100px',
          minWidth: '100px',
        },
        '& .column-header': {
          verticalAlign: 'middle',
          overflow: 'hidden',
          textOverflow: 'ellipsis',
          fontSize: '15px',
          padding: '8px 10px 8px 10px !important',
        },
        '& select': {
          verticalAlign: '-webkit-baseline-middle',
          padding: '1px 0',
          height: '25px',
          width: '100%',
          fontWeight: '400',
        },
        '& .table-container thead.header': {
          borderLeft: 0,
          borderRight: 0,
          borderTop: '2px solid #81868B',
          borderBottom: '2px solid #81868B',
          '& th': {
            padding: '5px 10px 5px 10px',
          },
        },
        '& table': {
          tableLayout: 'fixed',
          borderCollapse: 'collapse',
          borderSpacing: '0',
          '& tbody td': {
            verticalAlign: 'middle',
            textOverflow: 'ellipsis',
            overflow: 'hidden',
            whiteSpace: 'nowrap',
          },
        },
        '& .table-container colgroup.column-group': {
          width: '300px',
          minWidth: '300px',
        },
      },
    },
    {
      '& .file-picker': {
        maxWidth: '450px',
        '& .file-text': {
          display: 'block',
          whiteSpace: 'nowrap',
          overflow: 'hidden',
          textOverflow: 'ellipsis',
        },
        '& .clickable.error': {
          color: '#ffffff !important',
          margin: 'auto !important',
          marginLeft: '8px!important',
        },
      },
    }
  ),
});
